import { render, staticRenderFns } from "./taskbar-button.vue?vue&type=template&id=650a5c96"
import script from "./taskbar-button.vue?vue&type=script&lang=js"
export * from "./taskbar-button.vue?vue&type=script&lang=js"
import style0 from "./taskbar-button.vue?vue&type=style&index=0&id=650a5c96&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports